import { PayloadStates } from '@lore/utils';
import useEducatorProjectEvaluationsCreated from './useEducatorProjectEvaluationsCreated';
import useEducatorEventEvaluationsCreated from './useEducatorEventEvaluationsCreated';

export default function useEducatorEvaluationsCreated(network, timestamp) {
  const projectEvaluations = useEducatorProjectEvaluationsCreated(network, timestamp);
  const eventEvaluations = useEducatorEventEvaluationsCreated(network, timestamp);

  if (
    projectEvaluations.state === PayloadStates.FETCHING ||
    eventEvaluations.state === PayloadStates.FETCHING
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: {}
    };
  }

  if (projectEvaluations.state === PayloadStates.ERROR_FETCHING || eventEvaluations.state === PayloadStates.ERROR_FETCHING) {
    const projectCount = ((projectEvaluations && projectEvaluations.meta && projectEvaluations.meta.totalCount) || 0);
    const eventCount = ((eventEvaluations && eventEvaluations.meta && eventEvaluations.meta.totalCount) || 0);
    return {
      state: PayloadStates.RESOLVED,
      meta: { totalCount: projectCount + eventCount },
      partial: true,
      error: { projectError: projectEvaluations.error, eventError: eventEvaluations.error }
    };
  }

  // Normal resolved case, but guard against missing meta
  const projectCount = ((projectEvaluations && projectEvaluations.meta && projectEvaluations.meta.totalCount) || 0);
  const eventCount = ((eventEvaluations && eventEvaluations.meta && eventEvaluations.meta.totalCount) || 0);

  return {
    state: PayloadStates.RESOLVED,
    meta: {
      totalCount: projectCount + eventCount
    }
  };
}
